<!-- App.svelte -->
<script>
    import { Router, Route } from "svelte-routing";
    import Admin from "./layouts/Admin.svelte";
    import Auth from "./layouts/Auth.svelte";
    import toast, {Toaster} from "svelte-french-toast";
    import SubscriberHome from "./layouts/SubscriberHome.svelte";
    import { onMount } from "svelte";
    import { getSettings } from "./services/settingService";
    import { settings } from "./stores/settingsStore";
    import { selectedActiveYear } from "./stores/selectedActiveYear";
    import { closeModal, Modals } from "svelte-modals";

    export let url = "";

    async function getGlobalSettings() {
        getSettings().then((data) => {
            $settings = data.data;
            $selectedActiveYear = data.data.subscriptionActiveYear;
        }).catch(() => {
            toast.error("Impossibile accedere alle impostazioni globali");
        })
    }

    onMount(async () => {
        await getGlobalSettings();
    })
</script>



<Modals>
  <div
      slot="backdrop"
      class="backdrop"
      on:click={closeModal}
  >
  </div>
</Modals>

<Toaster
    containerClassName="flex flex-col gap-2"
    toastOptions={{ className: "mx-auto block" }}
/>

<Router url="{url}">
    {#if $settings}
      <Route path="auth/*auth" component={Auth} />
      <Route path="admin/*admin" component={Admin} />
      <Route path="subscribers/*subscribers" component={SubscriberHome}  />
      <Route component={SubscriberHome} />
    {/if}
</Router>

<style>
    :global(.wrapper) {
        position: relative !important;
    }
    .backdrop {
        display: flex;
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        background: rgba(0,0,0,0.50);
        z-index: 80;
    }
</style>